import type { InventoryEmissions } from '@/types';
import { api } from './api';

// The inventory's actual annual emissions on its default scenario, stacked
// by source type — the data for the promoted Inventory home page's one
// chart. Inventory-keyed; the reporting window + default scenario are
// resolved server-side (a plain GET, not a simulate-against-draft).
const emissionsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getEmissions: builder.query<InventoryEmissions, number>({
      query: (inventoryId) => `inventories/${inventoryId}/emissions`,
      providesTags: ['Emissions'],
    }),
  }),
});

export const { useGetEmissionsQuery } = emissionsApi;
